"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_sparql_serialize_1 = require("@comunica/bus-sparql-serialize");

var RdfString = require("rdf-string");

var stream_1 = require("stream");
/**
 * A comunica JSON SPARQL Serialize Actor.
 */


var ActorSparqlSerializeJson =
/*#__PURE__*/
function (_bus_sparql_serialize) {
  _inherits(ActorSparqlSerializeJson, _bus_sparql_serialize);

  function ActorSparqlSerializeJson(args) {
    _classCallCheck(this, ActorSparqlSerializeJson);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorSparqlSerializeJson).call(this, args));
  }

  _createClass(ActorSparqlSerializeJson, [{
    key: "testHandleChecked",
    value: function () {
      var _testHandleChecked = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(['bindings', 'quads', 'boolean'].indexOf(action.type) < 0)) {
                  _context.next = 2;
                  break;
                }

                throw new Error('This actor can only handle bindings or quad streams.');

              case 2:
                return _context.abrupt("return", true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function testHandleChecked(_x, _x2) {
        return _testHandleChecked.apply(this, arguments);
      }

      return testHandleChecked;
    }()
  }, {
    key: "runHandle",
    value: function () {
      var _runHandle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action, mediaType, context) {
        var data, empty, resultStream, _resultStream;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = new stream_1.Readable();

                data._read = function () {
                  return;
                };

                empty = true;

                if (!(action.type === 'bindings')) {
                  _context2.next = 11;
                  break;
                }

                resultStream = action.bindingsStream;
                data.push('[');
                resultStream.on('error', function (e) {
                  return data.emit('error', e);
                });
                resultStream.on('data', function (element) {
                  data.push(empty ? '\n' : ',\n');
                  data.push(JSON.stringify(element.map(RdfString.termToString)));
                  empty = false;
                });
                resultStream.on('end', function () {
                  data.push(empty ? ']\n' : '\n]\n');
                  data.push(null);
                });
                _context2.next = 34;
                break;

              case 11:
                if (!(action.type === 'quads')) {
                  _context2.next = 19;
                  break;
                }

                _resultStream = action.quadStream;
                data.push('[');

                _resultStream.on('error', function (e) {
                  return data.emit('error', e);
                });

                _resultStream.on('data', function (element) {
                  data.push(empty ? '\n' : ',\n');
                  data.push(JSON.stringify(RdfString.quadToStringQuad(element)));
                  empty = false;
                });

                _resultStream.on('end', function () {
                  data.push(empty ? ']\n' : '\n]\n');
                  data.push(null);
                });

                _context2.next = 34;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = data;
                _context2.t1 = JSON;
                _context2.next = 24;
                return action.booleanResult;

              case 24:
                _context2.t2 = _context2.sent;
                _context2.t3 = _context2.t1.stringify.call(_context2.t1, _context2.t2);
                _context2.t4 = _context2.t3 + '\n';

                _context2.t0.push.call(_context2.t0, _context2.t4);

                data.push(null);
                _context2.next = 34;
                break;

              case 31:
                _context2.prev = 31;
                _context2.t5 = _context2["catch"](19);
                setImmediate(function () {
                  return data.emit('error', _context2.t5);
                });

              case 34:
                return _context2.abrupt("return", {
                  data: data
                });

              case 35:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[19, 31]]);
      }));

      function runHandle(_x3, _x4, _x5) {
        return _runHandle.apply(this, arguments);
      }

      return runHandle;
    }()
  }]);

  return ActorSparqlSerializeJson;
}(bus_sparql_serialize_1.ActorSparqlSerializeFixedMediaTypes);

exports.ActorSparqlSerializeJson = ActorSparqlSerializeJson;